var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"examsList"},[_c('span',[_vm._v("token: "+_vm._s(_vm.userInfo.token))])])}
var staticRenderFns = []

export { render, staticRenderFns }